import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-manager-card',
    templateUrl: './manager-card.component.html',
    styleUrls: ['./manager-card.component.scss'],
    imports: [CommonModule]
})
export class ManagerCardComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
